export default __webpack_public_path__ + "static/media/nc.a9c6e731.svg";